import { SENTRY_DNS } from "./sentry";
import { GOOGLE_OPTIMIZE_EXPERIMENTS } from "./google_optimizer";
export { SENTRY_DNS, GOOGLE_OPTIMIZE_EXPERIMENTS };

export const THRESHOLD_FOR_INCLUDED_TAX_COMPLIANCE_BUNDLE =
  "2022-08-15 00:00:00Z";
